import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Messages from './index';
import SendMessage from './sendMessage/sendMessage';
import EditMessage from './sendMessage/editMessage';

const Users = props => {
  return (
    <Switch>
      <Route path="/messages/send" exact render={routeProps => <SendMessage {...routeProps} />} />
      <Route path="/messages/edit" exact render={routeProps => <EditMessage {...routeProps} />} />
      <Route path="/" component={Messages} />
    </Switch>
  );
};

export default Users;
